import _ from 'underscore';
import { useEffect, useState, useRef } from 'react';

import { PerfMarkerFactory } from '@bingads-webui/performance-marker';
import {
  getPreferenceForDashboard,
  getCardPreferenceOptions,
  setPreferenceForCard
} from '@bingads-webui-campaign/fluent-page-data';


const parentPerfMarker = PerfMarkerFactory.createMarker('FluentV2Overview_LegacyBackboneView');
parentPerfMarker.willInit();

export function useInitializeBackboneView({
  isPreferenceInitialized,
  preference,
  preferenceName,
  dashboardPreferenceKey,
  cardViewState,
  setCardViewState,
  dateRange,
  filter,
  newI18n,
  sesId,
  contentReady,
}) {
  const sesIdRef = useRef(sesId); // This is used to force refresh backbone instances
  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    if ((isPreferenceInitialized && !initialized) || sesIdRef.current !== sesId) {
      sesIdRef.current = sesId;
      setInitialized(true);
      const boardPreference = getPreferenceForDashboard({ preference, preferenceName, dashboardPreferenceKey });

      const newCarViewState = _.map(cardViewState, (cardState) => {
        if (!cardState.backboneCreator) {
          return cardState;
        }

        const perfMarker = parentPerfMarker.createChild(cardState.id);
        perfMarker.willInit();

        const cardPreferenceOptions = getCardPreferenceOptions(boardPreference, cardState.id);
        const backboneInstance = cardState.backboneCreator({
          cardPreferenceOptions,
          cardState,
          perfMarker,
          dateRange,
          filter,
          newI18n,
          contentReady,
        });

        backboneInstance.on('storeCardPreference', (options) => {
          setPreferenceForCard({
            preference,
            preferenceName,
            dashboardPreferenceKey,
            cardId: cardState.id,
            cardOptions: options,
          });
        });

        return {
          ...cardState,
          backboneInstance,
        };
      });

      setCardViewState(newCarViewState);
    }
  }, [cardViewState, dashboardPreferenceKey, dateRange, filter, initialized, isPreferenceInitialized, newI18n, preference, preferenceName, setCardViewState, sesId, contentReady]);
}
